import { VenueBasedMembershipGroupSerializer } from "@app-contexts/dashboard/features/memberships/data/types/membership-groups";
import { GtagItemType } from "@shared/lib/analytics/types/analytics-types";
import Box from "@ui-kit/layout/Box/Box.web";
import useItemGroupMembershipGroup from "../hooks/useItemGroupMembershipGroup";
import type { BaseItemGroupDisplayProps } from "../ItemGroup.props";
import ItemGroupDisplay from "../ItemGroupDisplay/ItemGroupDisplay.web";
import ItemGroupSkeleton from "../ItemGroupSkeleton/ItemGroupSkeleton.web";

export default function ItemGroupMembership({
  membershipLevelId,
  membershipGroupId,
  isParentLoading = false,
  isRenewalItemGroup = false,
  renewalMemberExpiryDate = undefined,
  updateItemTracking,
  membershipService,
  allowQuantityChange = true,
  ...rest
}: {
  membershipLevelId: number;
  membershipGroupId: number;
  updateItemTracking: ((input: GtagItemType) => void) | undefined;
  isParentLoading: boolean | undefined;
  isRenewalItemGroup?: boolean;
  renewalMemberExpiryDate?: string | undefined;
  allowQuantityChange?: boolean | undefined;
} & Omit<BaseItemGroupDisplayProps, "name">): JSX.Element {
  const { groupData, isFetching } = useItemGroupMembershipGroup(
    membershipGroupId,
    membershipLevelId,
    membershipService,
    updateItemTracking,
    rest.id
  );
  const showSkeleton = isFetching || isParentLoading;
  const membershipLevel = (
    groupData?.membership_levels as VenueBasedMembershipGroupSerializer["membership_levels"]
  )?.find((level) => level.id === membershipLevelId);
  const membershipRenewalFrequency = groupData?.renewal_frequency;
  return (
    <Box width="100%">
      {showSkeleton && <ItemGroupMembership.Skeleton />}
      {!showSkeleton && groupData && (
        <ItemGroupDisplay
          membershipService={membershipService}
          isRenewalItemGroup={isRenewalItemGroup}
          renewalMemberExpiryDate={renewalMemberExpiryDate}
          {...rest}
          name={groupData.name}
          subtitle={membershipLevel?.name}
          maxQuantity={membershipLevel?.purchase_limit}
          allowQuantityChange={allowQuantityChange}
          renewalFrequency={membershipRenewalFrequency}
        />
      )}
    </Box>
  );
}

ItemGroupMembership.Skeleton = ItemGroupSkeleton;
